'use client';

import { FC } from 'react';
import {
  Card,
  Flex,
  Heading,
  Toggle,
  Text,
  Separator,
  Pill,
} from '@/_components';
import { ToggleCardProps } from './ToggleCard.types';

export const ToggleCard: FC<ToggleCardProps> = ({
  onToggle,
  isDisabled,
  isChecked,
  description,
  isNew,
  title,
}) => {
  return (
    <Card padding={12}>
      <Flex isColumn={true} gap={6}>
        <Flex isBetween={true}>
          <Flex isYCentered={true} gap={2}>
            <Heading level={6}>{title}</Heading>
            {isNew && <Pill intent="success" label="New" size="small" />}
          </Flex>
          <Toggle
            isLabelHidden={true}
            label={title}
            isDisabled={isDisabled}
            isChecked={isChecked}
            onChange={onToggle}
          />
        </Flex>
        {description && (
          <>
            <Separator isLight={true} />
            <Text type="small" color="secondary">
              {description}
            </Text>
          </>
        )}
      </Flex>
    </Card>
  );
};
